module.exports = __webpack_public_path__ + "img/7.26242dd6.jpg";